import { createApp } from 'vue';
import ResultPage from './resultPage.vue';

const mountingResultPage = document.querySelector('[data-feature="resultPage"]');
if (mountingResultPage) {
	const app = createApp({
		name: 'ResultPageApp',
	});

	app.component('result-page', ResultPage);
	app.mount(mountingResultPage);
}
